export default function (error) {
  let message = '';
  switch (error.toLowerCase()) {
    case 'no_active_otp_request':
      message = 'Token expired, silakan kirim ulang OTP';
      break;
    case 'invalid_data':
      message = 'Kode verifikasi tidak tepat';
      break;
    case 'active_otp_already_sent':
      message = 'OTP sudah dikirim, tunggu beberapa saat';
      break;
    case 'already_verified_email':
      message = 'Nomor verifikasi sudah pernah dipakai';
      break;
    case 'already_verified_email':
      message = 'Email sudah pernah dipakai';
      break;
    case 'already_taken':
      message = 'Nomor sudah terdaftar';
      break;
    case 'missing_phone_number':
      message = 'Nomor handphone belum terdaftar';
      break;
    case 'missing_email':
      message = 'Email belum terdaftar';
      break;
    case 'unverified_phone':
      message = 'Nomor handphone belum terverifikasi';
      break;
    case 'invalid_phone_number':
      message = 'Nomor yang kamu masukkan salah. Silakan periksa kembali';
      break;
    case 'incorrect_otp':
      message = 'Kode verifikasi tidak tepat';
      break;
    case 'missing_parameter':
      message = 'Parameter tidak lengkap';
      break;
    case 'otp_maximum':
      message = 'OTP request maksimal 5 kali/hari';
      break;
    case 'invalid_phone_number':
      message = 'Nomor yang kamu masukan salah. Silahkan periksa kembali';
      break;
    case 'repeat_password':
      message = 'Password lama tidak boleh digunakan lagi';
      break;
    default:
      message = error;
      break;
  }
  return message;
}
